import React from 'react';

export default function VentriqoLogo({ className = '', dark = false }) {
  const textColor = dark ? '#FFFFFF' : '#0A0A0A';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 48" fill="none" className={className}>
      <path d="M4 8L20 40L36 8" stroke="#002FA7" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="20" cy="14" r="3" fill="#002FA7"/>
      <text x="48" y="36" fontFamily="'Space Grotesk','Arial Black',sans-serif" fontWeight="900" fontSize="32" letterSpacing="-1.5" fill={textColor}>VENTRIQO</text>
    </svg>
  );
}
